export default "__VITE_ASSET__D7dpu0SH__"